import { render, staticRenderFns } from "./feedbackRestWiseReport.vue?vue&type=template&id=ed51523e&scoped=true&"
import script from "./feedbackRestWiseReport.vue?vue&type=script&lang=js&"
export * from "./feedbackRestWiseReport.vue?vue&type=script&lang=js&"
import style0 from "./feedbackRestWiseReport.vue?vue&type=style&index=0&id=ed51523e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed51523e",
  null
  
)

export default component.exports